import React, {CSSProperties, ReactElement} from "react";
import {LocalisedTypography} from "@components/localisation/LocalisedTypography";
import {connect} from "react-redux";
import {update as updateDialog} from "@redux/slices/dialog";
import {Update} from "@redux/slices/base";
import {COLOURS} from "@components/core/theme";

const styles: Record<string, CSSProperties> = {
    close: {
        cursor: "pointer",
        flexShrink: 0,
        height: 28,
        marginTop: 2,
        marginRight: 2,
        padding: 4,
        width: 28
    },
    contents: {
        alignItems: "center",
        backgroundColor: COLOURS.overlay,
        display: "flex",
        justifyContent: "center",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        position: "absolute",
        zIndex: 200
    },
    dialog: {
        backgroundColor: COLOURS.parchment,
        border: `2px solid ${COLOURS.agedBorder}`,
        borderRadius: 8,
        boxShadow: "0 8px 32px rgba(0,0,0,0.45)",
        display: "flex",
        flexDirection: "column",
        margin: 16,
        maxHeight: "85vh",
        maxWidth: 600,
        minHeight: 550,
        padding: 16,
        width: "calc(100% - 64px)"
    },
    titleBar: {
        borderBottom: `1px solid ${COLOURS.agedBorder}`,
        display: "flex",
        marginBottom: 8,
        paddingBottom: 8
    },
    title: {
        color: COLOURS.forestGreen,
        display: "flex",
        flexGrow: 1,
        fontFamily: "Georgia, 'Palatino Linotype', serif",
        justifyContent: "center"
    },
    subtitle: {
        color: COLOURS.amber,
        fontFamily: "Georgia, 'Palatino Linotype', serif",
        fontSize: "0.75rem",
        fontStyle: "italic",
        textAlign: "center" as const,
    }
};

interface IDialog {
    children: ReactElement | ReactElement []
    close?: boolean
    subtitle?: string
    title?: string
    updateDialog: Update
}

function Dialog({children, close, subtitle, title, updateDialog}: IDialog) {
    const handleCloseClick = () => {
        updateDialog({update: {}});
    };

    return (
        <div style={styles.contents}>
            <div style={styles.dialog}>
                {(title || close) &&
                    <div style={styles.titleBar}>
                        <div style={{flexGrow: 1}}>
                            <h1 style={styles.title}>
                                {title && <LocalisedTypography content={title}/>}
                            </h1>
                            {subtitle && <div style={styles.subtitle}>{subtitle}</div>}
                        </div>
                        {close && (
                            <div onClick={handleCloseClick} style={styles.close}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <line x1="4" y1="4" x2="16" y2="16" stroke={COLOURS.forestGreen} strokeWidth="2.5" strokeLinecap="round"/>
                                    <line x1="16" y1="4" x2="4" y2="16" stroke={COLOURS.forestGreen} strokeWidth="2.5" strokeLinecap="round"/>
                                </svg>
                            </div>
                        )}
                    </div>
                }
                {children}
            </div>
        </div>
    );
}
const mapStateToProps = (_: never) => ({
});
const connected = connect(mapStateToProps, {
    updateDialog
})(Dialog);
export {connected as Dialog}
